import Image from 'next/image';
import cn from 'classnames';
import Video from 'react-scale/components/elements/video';
import Logo from 'react-scale/components/website/Logo';
import MeshBackground from 'react-scale/components/elements/webgl';
import { Header, CTA, Navigation } from 'react-scale/components';

import s from './hero.module.css';

const HeroVideo = ({ className }) => (
  <div className={cn('text-center w-full', className)}>
    <div className="relative w-full lg:hidden">
      <Video
        url="https://scaleai.wistia.com/medias/4ygnd9t30t"
        blackButton
        poster="/static/images/pages/document/covers/hero.png"
        smallButton
      />
    </div>
    <div className="hidden max-w-3xl cursor-pointer lg:block xl:w-full">
      <Video
        url="https://scaleai.wistia.com/medias/4ygnd9t30t"
        blackButton
        poster="/static/images/pages/document/covers/hero.png"
        smallButton
      />
    </div>
  </div>
);

const HeroDocument = ({ title, subtitle, cta }) => (
  <div className="relative">
    <MeshBackground />
    <div className={s.heroBody}>
      <Header
        title="Scale Document AI: Template-Free, High-Quality Extraction"
        description="High-quality document processing, classification, and key-value extraction. Fine-tuned ML models at scale with no templates, and no maintenance."
        canonical="https://image3-3scale.com/document-ai"
        ogImg="/static/images/pages/document/OG.png"
        twImg="/static/images/pages/document/OG.png"
        videoOverlay
      />
      <Navigation
        title={{
          text: 'products'
        }}
        links={[
          {
            text: 'Why Document AI',
            href: '#why-docai'
          },
          {
            text: 'Industries',
            href: '#industries'
          },
          {
            text: 'How It Works',
            href: '#how-it-works'
          },
          {
            text: 'Customers',
            href: '#customers'
          }
        ]}
      />
      <div className="container flex items-center w-full py-[72px] space-x-[72px] lg:pb-[177px] lg:pt-[169px]">
        <div className="relative w-full lg:w-auto lg:min-w-max flex-grow-1">
          <div className="relative">
            <div className="flex flex-col items-center justify-center mb-12 sm:flex-row sm:mb-12 md:mb-8 lg:mb-0 sm:justify-start">
              <span className="block mb-6 md:hidden">
                <Image
                  alt="scale-logo"
                  src="/static/images/icons/products/document.svg"
                  loading="eager"
                  priority
                  layout="fixed"
                  width={100}
                  height={100}
                />
              </span>
              <span className="hidden md:flex">
                <Image
                  alt="scale-logo"
                  src="/static/images/icons/products/document.svg"
                  loading="eager"
                  priority
                  layout="fixed"
                  width={105}
                  height={105}
                />
              </span>
              <div className="flex sm:block items-center flex-col sm:ml-[35px]">
                <div className="mb-4 lg:hidden max-w-min">
                  <Logo width="68px" fill="#A3A3A3" fillmobile="#A3A3A3" />
                </div>
                <div className="hidden mb-4 lg:block">
                  <Logo width="82px" fill="#A3A3A3" fillmobile="#A3A3A3" />
                </div>
                <h1 className={s.title}>{title}</h1>
              </div>
            </div>
            <p dangerouslySetInnerHTML={{ __html: subtitle }} className={s.subtitle} />
            <HeroVideo className="lg:hidden" />
            <div className={s.cta}>
              <CTA cta={cta} />
            </div>
          </div>
        </div>

        <HeroVideo className="hidden lg:block" />
      </div>
    </div>
  </div>
);

export default HeroDocument;
